// ════════════════════════════════════════════════════════════════════════
//  Wer an dieser Schule ein Konto hat
//
//  Die Kopfzeile der Schule zählt („2 Lehrkräfte, 1 in der Leitung“). Wer die
//  Leitung IST, stand nirgends – und genau das ist die Frage, bevor man einen
//  Schuladmin einlädt: sonst lädt man zum zweiten Mal dieselbe Person ein.
//
//  Keine E-Mail-Adresse: die steht in `auth.users` und nicht in `profiles`. Die
//  Liste beantwortet „wer“, nicht „wie erreiche ich“. Für den zweiten Fall gibt
//  es den Ansprechpartner der Schule weiter oben.
//
//  Und weiterhin keine Kinder: `students` und `progress` haben für die
//  Plattform keine Lesepolicy.
// ════════════════════════════════════════════════════════════════════════

import type { SchoolPerson } from "../lib/data.js";
import own from "./schoolPeople.module.css";
import shell from "../../../shared/components/shell.module.css";

const ROLE_LABEL: Record<SchoolPerson["role"], string> = {
  school_admin: "Schulleitung",
  teacher: "Lehrkraft",
};

const dateFormat = new Intl.DateTimeFormat("de-DE", {
  timeZone: "Europe/Berlin",
  day: "2-digit",
  month: "2-digit",
  year: "numeric",
});

export function SchoolPeople({
  people,
  pending,
}: {
  people: readonly SchoolPerson[];
  pending: boolean;
}) {
  return (
    <div className={`${shell.card} ${shell.spaced}`}>
      <h2 className={shell.title} style={{ fontSize: "1.15rem" }}>
        Konten
      </h2>

      {pending && <p className={shell.empty}>Wird geladen …</p>}

      {!pending && people.length === 0 && (
        <p className={shell.empty}>
          Diese Schule hat noch kein Konto. Laden Sie unten die Schulleitung ein – sie
          legt ihre Lehrkräfte danach selbst an.
        </p>
      )}

      {people.length > 0 && (
        <table>
          <thead>
            <tr>
              <th scope="col">Name</th>
              <th scope="col">Rolle</th>
              <th scope="col">Seit</th>
            </tr>
          </thead>
          <tbody>
            {people.map((person) => (
              <tr key={person.id}>
                <td>{person.name}</td>
                <td>
                  {person.role === "school_admin" ? (
                    <span className={own.lead}>{ROLE_LABEL[person.role]}</span>
                  ) : (
                    ROLE_LABEL[person.role]
                  )}
                </td>
                <td className={own.quiet}>{dateFormat.format(new Date(person.since))}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
